import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ChangeLink, EditPanel, SettingRow, useSaveWithToast } from "../../ui";

interface ResetAreaSettingsRowProps {
  /** Deletes the area's settings and reads them again: they are the company's now. */
  onReset: () => Promise<unknown>;
}

/** For an area with document settings of its own: delete them, so the area uses the company's again. */
export default function ResetAreaSettingsRow({
  onReset,
}: ResetAreaSettingsRowProps) {
  const { t } = useTranslation();
  const { save, saving, error } = useSaveWithToast();
  const [confirming, setConfirming] = useState(false);

  const reset = async () => {
    await save(onReset, {
      successMessage: t("work_security_area_reset_done"),
      errorMessage: () => t("work_security_area_reset_failed"),
    });
  };

  return (
    <SettingRow
      label={t("work_security_area_reset_label")}
      description={t("work_security_area_reset_description")}
      action={
        confirming ? undefined : (
          <ChangeLink
            label={t("work_security_area_reset")}
            onClick={() => setConfirming(true)}
          />
        )
      }
    >
      {confirming && (
        <EditPanel
          onSave={reset}
          onCancel={() => setConfirming(false)}
          saving={saving}
          error={error}
          saveLabel={t("work_security_area_reset_confirm")}
        >
          <p className="text-sm text-gray-700">
            {t("work_security_area_reset_confirm_description")}
          </p>
        </EditPanel>
      )}
    </SettingRow>
  );
}
